/**
 * @file 浏览器功能相关 utils
 */
/**
 * 打开一个新窗口
 * 效果同 window.open，唯一的不同是我们增加了 fallback 的处理，如果 window.open 失败将在当前页面打开
 *
 * @category Browser
 * @param url - 新开窗口 url
 */
export const openWindowSafe = (url) => {
    const reference = window.open(url);
    // 新开窗口被拦截或者在 WebView 中打开将无法正常跳转，此时改为 window.location
    if (!reference) {
        window.location.href = url;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvd3Nlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mdW5jdGlvbnMvYnJvd3Nlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVIOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxDQUFDLEdBQVcsRUFBRSxFQUFFO0lBQzVDLE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7SUFFbEMscURBQXFEO0lBQ3JELElBQUksQ0FBQyxTQUFTLEVBQUU7UUFDZCxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUE7S0FDM0I7QUFDSCxDQUFDLENBQUEifQ==